// extracted by mini-css-extract-plugin
export default {"hr":"HorizontalSeparator_hr__8YeyA"};